
export const FeatureFlags = {
  // General/Common feature flags
  FEATURES: {
    LOCALIZATION: process.env.VUE_APP_FEATURE_LOCALIZATION === 'true',
    KEY_CLOAK_SSO: process.env.VUE_APP_FEATURE_KEY_CLOAK_SSO === 'true',
    
    // Navigation/Route Features
    EXPLORE: process.env.VUE_APP_FEATURE_EXPLORE === 'true',
    EVENTS: process.env.VUE_APP_FEATURE_EVENTS === 'true',
    ANALYZE: process.env.VUE_APP_FEATURE_ANALYZE === 'true',
    EXPLORE_CLUSTER: process.env.VUE_APP_FEATURE_EXPLORE_CLUSTER === 'true',
    MARKETPLACE: process.env.VUE_APP_FEATURE_MARKETPLACE === 'true',
    SOCIAL: process.env.VUE_APP_FEATURE_SOCIAL === 'true',
    LEADERBOARD: process.env.VUE_APP_FEATURE_LEADERBOARD === 'true',
    MESSENGER: process.env.VUE_APP_FEATURE_MESSENGER === 'true',
    PORTFOLIO: process.env.VUE_APP_FEATURE_PORTFOLIO === 'true',
    PORTFOLIO_V3: process.env.VUE_APP_PORTFOLIO_V3_ENABLED === 'true',
    PORTFOLIO_BROKERAGE: process.env.VUE_APP_FEATURE_PORTFOLIO_BROKERAGE === 'true',
    PORTFOLIO_WALLETS: process.env.VUE_APP_FEATURE_PORTFOLIO_WALLETS === 'true',
  },

  _INTERNAL: {
    TEAM_OF_ENABLED: process.env.VUE_APP_TEAM_OF_ENABLED === 'true',
    TEAM_BO_ENABLED: process.env.VUE_APP_TEAM_BO_ENABLED === 'true',
  }
} as const;

export type FeatureFlagKey = keyof typeof FeatureFlags.FEATURES;

export function isFeatureEnabled(flag: FeatureFlagKey): boolean {
  return FeatureFlags.FEATURES[flag];
}

export function areFeaturesEnabled(...flags: FeatureFlagKey[]): boolean {
  return flags.every(flag => FeatureFlags.FEATURES[flag]);
}

// Check if at least one feature is enabled
export function isAnyFeatureEnabled(...flags: FeatureFlagKey[]): boolean {
  return flags.some(flag => FeatureFlags.FEATURES[flag]);
}